import { render, staticRenderFns } from "./DemandDetails.vue?vue&type=template&id=c97c99b4&"
import script from "./DemandDetails.vue?vue&type=script&lang=js&"
export * from "./DemandDetails.vue?vue&type=script&lang=js&"
import style0 from "./DemandDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports